module.exports = {
  FULL_TIME: 'full-time',
  PART_TIME: 'part-time',
  FIXED_TERM: 'fixed-term',
  INTERNSHIP: 'internship',
  CONTRACTOR: 'contractor',
  APPRENTICESHIP: 'apprenticeship',
};
